<template>
  <f7-page>
    <f7-navbar
      class="no-shadow"
      :style="appTheme"
    >
      <f7-nav-left name="frmVolcarMercanciaDetalle-nav-lefth">
        <f7-link @click="NavigateBack()">
          <img
            alt="iconBack"
            src="@/static/icons/back.svg"
          >
        </f7-link>
      </f7-nav-left>
      <f7-nav-title>
        {{ $t('production.dump.batchDetails.title') }}
      </f7-nav-title>
    </f7-navbar>
    <PCInformacionLineaPunto
      class="navbar-oscuro-1"
      :activo="activo"
    />
    <div class="div-001">
      <div class="div-frmVolcarMercanciaDetalle">
        <PCVistaVolcarPartida
          :existencia-seleccionada="existenciaSeleccionada"
          :partida-seleccionada="partidaSeleccionada"
        />
      </div>
    </div>
  </f7-page>
</template>

<script>
import { Log } from '@/js/common/HIDebuggingSupport';
import eventBus from '@/js/event-bus';
import PCInformacionLineaPunto from '@/components/production/traceability/PCInformacionLineaPunto.vue';
import PCVistaVolcarPartida from '@/components/production/traceability/PCVistaVolcarPartida.vue';
import { f7 } from 'framework7-vue';

export default {
  name: 'FrmDetailDumpMerchandise',
  components: {
    PCInformacionLineaPunto,
    PCVistaVolcarPartida,
  },
  props: {
    activo: {
      type: Boolean,
      default: null,
    },
    existenciaSeleccionada: {
      type: Object,
      default: null,
    },
    partidaSeleccionada: {
      type: Object,
      default: null,
    },
  },

  computed: {
    appTheme() {
      return {
        '--f7-navbar-text-color': '#fff',
      };
    },
  },

  created() {
    this.ActivarListener();
  },

  methods: {
    NavigateBack() {
      f7.views.main.router.back();
    },
    ActivarListener() {
      Log(this, this.ActivarListener.name);
      eventBus.on('PCVistaVolcarPartida_mercanciaVolcada', () => {
        this.NotificarVolcadoDeMercancia();
      });
    },

    /** Método notificarVolcadoDeMercancia */
    NotificarVolcadoDeMercancia() {
      Log(this, this.NotificarVolcadoDeMercancia.name);
      eventBus.emit('movimientoRealizado'); // Para Busquedas por partida
      eventBus.emit('frmVolcarMercanciaDetalle_partidaVolcada'); // Para las busquedas desde UL
      f7.views.main.router.back();
    },
    /** Método volcadoDeMercanciaTotal */
    restablecerValoresDelFrm() {
      Log(this, this.restablecerValoresDelFrm.name);
      this.seleccionExistencia = null;
    },
    /** Método CerrarPopup */
    CerrarPopup() {
      Log(this, this.CerrarPopup.name);
      f7.popup.close('.vistaMercanciaUL-popup', true);
    },
  },
};
</script>

<style lang="scss">
.icon-unidad-volcado-input {
  margin-top: -10px;
  margin-left: 13px;
  color: green;
}

.texto-calculoCajas {
  color: darkgray;
}

.input-cantidades {
  width: 100%;
}

.div-frmVolcarMercanciaDetalle {
  margin-top: 70px;
}

.navbar-oscuro-1 {
  background-color: var(--his-darkgray);
}
</style>
